import {forwardRef, useEffect, useRef} from 'react';

type AudioPlayerProps = {
    src: string;
    volume?: number;
};

export const AudioPlayer = forwardRef<HTMLAudioElement, AudioPlayerProps>(
    ({src, volume = 1}, ref) => {
        const audioRef = useRef<HTMLAudioElement | null>(null);

        useEffect(() => {
            if (audioRef.current) {
                audioRef.current.volume = volume;
            }
        }, [volume]);

        return (
            <audio
                preload="metadata"
                ref={element => {
                    audioRef.current = element;
                    if (typeof ref === 'function') {
                        ref(element);
                    } else if (ref) {
                        ref.current = element;
                    }
                }}
                src={src}
            />
        );
    }
);
